import React from 'react';
import '../styles/Card.css';

const Card = ({ card, isRevealed, onReveal, position }) => {
  const handleClick = () => {
    onReveal();
  };

  return (
    <div
      className={`card-container ${position}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={`card ${isRevealed ? 'revealed' : ''}`}>
        <div className="card-face card-back">
          <img src="/images/Back.png" alt="Card back" />
        </div>
        <div className="card-face card-front">
          <img src={`/${card.image}`} alt={card.name} />
          <div className="card-info">
            <h3>{card.name}</h3>
            <p>{card.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
